import { useSyncExternalStore } from 'react';

const query = typeof window === 'undefined' ? null : window.matchMedia('(prefers-color-scheme: dark)');
const subscribe = (changed: () => void) => {
  query?.addEventListener('change', changed);
  return () => query?.removeEventListener('change', changed);
};
const snapshot = () => query?.matches ?? false;
const serverSnapshot = () => false;

export function useDeviceDarkMode(): boolean {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
